import Footer from '../../components/footer/footer.component';
import Navbar from '../../components/navbar/navbar.component';
import Header from '../../components/header/header.component';
import About from '../../components/about/about.component';
import WhyUs from '../../components/why-us/why-us.component';
import ContactUs from '../../components/contact-us/contact-us.component';
import Testimonials from '../../components/testimonials/testimonials.component';
import ForOrder from '../../components/for-order/for-order.component';
import Gallery from '../../components/gallery/gallery.component';

const Home = () => {
  return (
    <div className='App'>
      <Navbar />
      <Header />
      <About />
      <WhyUs />
      <Gallery />
      <ForOrder />
      <ContactUs />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default Home;
